// @flow
import React, { Component, Fragment } from 'react';
import SettingSection from 'components/settings/SettingSection/SettingSection';
import SettingProfileContainer from './SettingProfileContainer';
import SettingsEtcContainer from './SettingsEtcContainer';
import SettingEmailContainer from './SettingEmailContainer';
import SettingPasswordContainer from './SettingPasswordContainer';
import SettingProfileLinksContainer from './SettingProfileLinksContainer';

type Props = OwnProps & {
  type: string,
};

class SettingSections extends Component<Props> {
  render() {
    const { type } = this.props;
    return (
      <Fragment>
        {type === 'user' && (
          <SettingSection name="회원정보수정">
            <SettingProfileContainer />
          </SettingSection>
        )}
        {/* <SettingSection name="소셜 정보">
          <SettingProfileLinksContainer />
        </SettingSection> */}
        {type === 'email' && (
          <SettingSection name="이메일 변경">
            <SettingEmailContainer />
          </SettingSection>
        )}
        {type === 'password' && (
          <SettingSection name="비밀번호 변경">
            <SettingPasswordContainer />
          </SettingSection>
        )}
        {/* <SettingSection name="회원탈퇴">
          <SettingsEtcContainer />
        </SettingSection> */}
      </Fragment>
    );
  }
}

export default SettingSections;



// WEBPACK FOOTER //
// ./src/containers/settings/SettingSections.js